import { useEffect } from "react";
import { SITE } from "@/data/site";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Lightweight SEO manager: title, meta description, canonical,
 * Open Graph, Twitter cards, and JSON-LD structured data (Schema.org).
 */
export default function Seo({ title, description, path = "", image, schema }) {
  const fullTitle = title ? `${title} | ${SITE.name}` : `${SITE.name} — ${SITE.baseline}`;
  const url = `${SITE.url}${path}`;
  const ogImage = image || "https://images.pexels.com/photos/20862827/pexels-photo-20862827.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

  useEffect(() => {
    document.title = fullTitle;
    setMeta("name", "description", description);
    setLink("canonical", url);

    // Open Graph
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", ogImage);
    setMeta("property", "og:site_name", SITE.name);
    setMeta("property", "og:locale", "fr_FR");

    // Twitter
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", ogImage);

    // JSON-LD
    const id = "seo-jsonld";
    let script = document.getElementById(id);
    if (schema) {
      if (!script) {
        script = document.createElement("script");
        script.id = id;
        script.type = "application/ld+json";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(schema);
    } else if (script) {
      script.remove();
    }
  }, [fullTitle, description, url, ogImage, schema]);

  return null;
}

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "EducationalOrganization",
  name: SITE.name,
  url: SITE.url,
  description: SITE.baseline,
  address: [
    { "@type": "PostalAddress", streetAddress: "4 Allée des Garays", postalCode: "91120", addressLocality: "Palaiseau", addressCountry: "FR" },
    { "@type": "PostalAddress", streetAddress: "7–9 Rue Saint-Just", postalCode: "93130", addressLocality: "Noisy-le-Sec", addressCountry: "FR" },
    { "@type": "PostalAddress", streetAddress: "6 Cours Raoult", postalCode: "77100", addressLocality: "Meaux", addressCountry: "FR" },
    { "@type": "PostalAddress", streetAddress: "16 Avenue Jean Jaurès", postalCode: "94600", addressLocality: "Choisy-le-Roi", addressCountry: "FR" },
  ],
  telephone: "01 69 09 27 27",
  email: "contact@educaser.fr",
};
